import React from 'react';

const Footer = () => {
    return (
      <footer className="app-footer">
        <span className="d-inline-block">Todos os direitos reservados a Uzer Tecnologia &copy; {new Date().getFullYear()}</span>
      </footer>
    );
  }
;

export default Footer;
